<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">业务管理中心</p>
      </el-col>
    </el-row>

    <div class="pt20 pb20 pl20 pr20">
      <p class="font-14 mb5 flex-box al-c">
        <img class="mr5" :src="`${baseUrl}images/icon-chart.png`" height="14">
        共有<span>{{ serveNum ? serveNum : '-' }}</span>个业务，我管理的<span>{{ managerNum ? managerNum : '-' }}</span>个。
      </p>
      <p class="mt10 mb5 flex-box al-c orange cu-p" v-if="exceptionNum">
        <i class="el-icon-warning"></i>
        <router-link class="ml5 orange" :to="{ name: 'officeBizException' }">有 {{ exceptionNum ? exceptionNum : '-' }} 个事务超时。[点击查看]</router-link>
      </p>
      <p class="mt10 mb5 flex-box al-c green cu-p" v-else>
        <i class="el-icon-success"></i>
        <router-link class="ml5 green" :to="{ name: 'officeBizException' }">当前没有事务异常。[点击查看]</router-link>
      </p>
      <div class="mt20 tx-c">
        <el-button class="w50" type="primary" round @click="goPage">业务管理中心</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardServeCenter",
  props: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      serveNum: 0,
      managerNum: 0,
      exceptionNum: 0
    };
  },
  computed: {},
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$http
        .post("serve/getServeManaInfo")
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.serveNum = data.resData.serveNum;
            this.managerNum = data.resData.managerNum;
            this.exceptionNum = data.resData.exceptionNum;
          }
        })
        .catch(() => {});
    },
    goPage() {
      this.$router.push({
        name: "officeBiz"
      });
    }
  }
};
</script>

<style scoped>
</style>
